"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recordsPublicDetails = exports.recordsLogin = exports.recordsForgotPassword = exports.recordsExpiryMagicLinkPassword = exports.recordsEmailProvider = exports.recordsDetails = exports.recordSuccess = exports.recordReset = exports.recordError = void 0;
var _records = require("./records.constant");
// @flow

// common success
var recordSuccess = function recordSuccess(actionType, data) {
  return {
    type: _records.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.recordSuccess = recordSuccess;
var recordError = function recordError(actionType, error) {
  return {
    type: _records.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * Login
 * @param payload
 * @returns api response
 * @description this function used to user login by its credencials.
 */
exports.recordError = recordError;
var recordsLogin = function recordsLogin(payload) {
  return {
    type: _records.actionTypes.RECORDS_LOGIN,
    payload: payload
  };
};

/**
 * Forgot Password
 * @param payload
 * @returns api response
 * @description this function used to user forgot password by its credencials.
 */
exports.recordsLogin = recordsLogin;
var recordsForgotPassword = function recordsForgotPassword(payload) {
  return {
    type: _records.actionTypes.RECORDS_FORGOT_PASSWORD,
    payload: payload
  };
};

/**
 * Forgot Password
 * @param payload
 * @returns api response
 * @description this function used to user forgot password by its credencials.
 */
exports.recordsForgotPassword = recordsForgotPassword;
var recordsExpiryMagicLinkPassword = function recordsExpiryMagicLinkPassword(payload) {
  return {
    type: _records.actionTypes.RECORDS_EXPIRY_MAGIC_LINK_PASSWORD,
    payload: payload
  };
};

/**
 * record details
 * @param payload
 * @returns api response
 * @description this function used to fetch details.
 */
exports.recordsExpiryMagicLinkPassword = recordsExpiryMagicLinkPassword;
var recordsDetails = function recordsDetails(payload) {
  return {
    type: _records.actionTypes.RECORDS_DETAILS,
    payload: payload
  };
};

/**
 * public details
 * @param payload
 * @returns api response
 * @description this function used to fetch details.
 */
exports.recordsDetails = recordsDetails;
var recordsPublicDetails = function recordsPublicDetails(payload) {
  return {
    type: _records.actionTypes.PUBLIC_DETAILS,
    payload: payload
  };
};

/**
 * records exists or not
 * @param payload
 * @returns api response
 * @description this function used to check record exists or not
 */
exports.recordsPublicDetails = recordsPublicDetails;
var recordsEmailProvider = function recordsEmailProvider(data) {
  return {
    type: _records.actionTypes.EMAIL_PROVIDER,
    payload: data
  };
};

/**
 * Reset Record
 * @param payload
 * @returns api response
 * @description this function used to user forgot password by its credencials.
 */
exports.recordsEmailProvider = recordsEmailProvider;
var recordReset = function recordReset(payload) {
  return {
    type: _records.actionTypes.RECORDS_RESET,
    payload: payload
  };
};
exports.recordReset = recordReset;